module.exports = __webpack_public_path__ + "img/电力-电力线缆.0cc132c5.jpg";